<template>
    <v-container fluid>

        <!-- HEADER -->
        <v-row class="content-header">
            <v-col>
                <page-title title="Dreambuild"></page-title>
            </v-col>

<!--            <v-col class="text-right">-->
<!--                <v-btn v-if="showAll" tile small color="primary" class="ml-3" @click="showOnlyValid">-->
<!--                    Esconder Duplicados/Data invalida-->
<!--                </v-btn>-->
<!--                <v-btn v-else tile small color="success" class="ml-3" @click="showAllParticipation">-->
<!--                    Mostrar todos-->
<!--                </v-btn>-->
<!--            </v-col>-->
            <v-col cols="12" md="2" class="text-right mr-2">
                <p class="mb-0">A mostrar: <span style="font-size: 18px">{{this.participations.length}}</span> <span style="font-size: 11px;">( {{ this.totalParticipation }} participações)</span></p>
                <v-divider/>
                <p class="mb-0"><strong>Total:</strong> <span style="font-size: 18px">{{this.originalParticipations.length}}</span> <span style="font-size: 11px;">( {{this.totalOriginalParticipation}} participações)</span></p>
            </v-col>
        </v-row>
        <v-row>
            <v-col style="display: flex; align-items: center;">
                Visibilidade Participações:
                <v-btn-toggle
                        v-model="participationView"
                        :color="colorView"
                        mandatory
                        variant="outlined"
                        class="ml-1"
                        @change="filterAnnulled"
                >
                    <v-btn value="all" small style="background-color: white"><strong>Todos</strong></v-btn>
                    <v-btn value="valid" small style="background-color: white"><strong>Válidos</strong></v-btn>
                    <v-btn value="annulled" small style="background-color: white"><strong>Anulados</strong></v-btn>
                    <v-btn value="duplicatedOutbound" small style="background-color: white"><strong>Duplicados / ForaIntervalo</strong></v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>

        <!-- PAGE CONTENT -->
        <v-row>
            <v-col>
                <div class="staff_v-card">
                    <v-simple-table class="staff_table">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th></th>
                                <th class="text-left">
                                    Nome
                                </th>
                                <th class="text-left">
                                    Email
                                </th>
                                <th class="text-left">
                                    Identificação
                                </th>
                                <th class="text-left">
                                    Telefone
                                </th>
                                <th class="text-center">
                                    Idade
                                </th>
                                <th class="text-left">
                                    Nome Loja
                                </th>
                                <th class="text-left">
                                    Data Compra
                                </th>
                                <th class="text-left">
                                    Fatura
                                </th>
                                <th class="text-left">
                                    Data participação
                                </th>
                                <th class="text-center">
                                    Valor
                                </th>
                                <th class="text-center">
                                    Num.Inscrições
                                </th>
                                <th class="text-center">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                    v-for="item in participations"
                                    :key="item.participationId"
                                    :class="[item.duplicated ? 'duplicated-line' : (item.purchaseDate < '2026-02-01' ? 'invalid-date' : '')]"
                            >
                                <td><strong>{{ item.numParticipacao }}</strong></td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.clientIdentification }}</td>
                                <td>{{ item.phone }}</td>
                                <td class="text-center">{{ item.age }}</td>
                                <td>{{ item.nameStore }}</td>
                                <td :style="[item.purchaseDate < '2026-02-01' || item.purchaseDate > '2026-03-31' ? {'color': 'red'} : '']">
                                    {{ item.purchaseDate }}
                                </td>
                                <td>
                                    <a :href="'https://static.bicimax.com/dreamBuild/' + item.fileName" target="_blank"
                                       class="ml-3">
                                        <i class="fas fa-fw fa-file-alt"></i>
                                    </a>
                                    {{ item.numInvoice }}
                                </td>
                                <td>{{ item.first_created_at.substring(0, 19) }}</td>
                                <td class="text-right">{{ $money(item.valueInvoice) }}</td>
                                <td class="text-center">{{ item.NumParticipations }}</td>
                                <td class="text-center">
                                    <v-btn
                                            color="error"
                                            x-small
                                            @click="dialogConfirm=true;selectedGroup=item.numParticipacao"
                                            :disabled="item.isInvalid == '1'"
                                    >
                                        Anular
                                    </v-btn>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogConfirm" max-width="500">
            <v-card>
                <v-card-title>{{ $t('confirmChange') }}</v-card-title>
                <v-card-text>
                    Tem a certeza que pretende anular a participação ?
                </v-card-text>
                <v-card-actions>
                    <v-btn tile small @click="dialogConfirm=false;selectedGroup=''">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn tile small color="success" @click="updateStateParticipation()">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from "axios";

//Get form stats by id of form (responses + postpone)
export default {
    data: function () {
        return {
            participations: [],
            originalParticipations: [],
            showAll: true,
            dialogConfirm: false,
            selectedGroup: '',
            selectedIdGroup: '',
            participationView: 'all',
            colorView: 'info'
        }
    },
    mounted() {
        this.getDrawResults();
    },
    methods: {
        getDrawResults() {
            let loader = this.$loading.show();

            axios.get(api.drawResults())
                    .then(response => {
                        let responseData = response.data
                        if (responseData.status === 'OK') {
                            loader.hide()
                            this.participations = responseData.data

                            this.originalParticipations = JSON.parse(JSON.stringify(this.participations));
                        }
                    })
                    .catch(response => {
                        loader.hide()
                    })
        },
        updateStateParticipation() {

            console.log(this.selectedGroup);

            let loader = this.$loading.show();

            let data = {
                groupToInvalid: this.selectedGroup
            }

            axios.post(api.invalidateResult(), data)
                    .then(response => {
                        let responseData = response.data
                        if (responseData.status === 'OK') {
                            loader.hide()

                            //Clear values
                            this.dialogConfirm = false;
                            this.selectedGroup = '';

                            //Update page
                            this.getDrawResults();
                        }
                    })
                    .catch(response => {
                        loader.hide()
                    })

        },
        showOnlyValid() {
            this.showAll = false;

            let duplicates = document.getElementsByClassName('duplicated-line');
            let invalidDates = document.getElementsByClassName('invalid-date');

            for (const duplicate of duplicates) {
                duplicate.style.display = 'none';
            }
            for (const invalid of invalidDates) {
                invalid.style.display = 'none';
            }
        },
        showAllParticipation() {
            this.showAll = true;

            let duplicates = document.getElementsByClassName('duplicated-line');
            let invalidDates = document.getElementsByClassName('invalid-date');

            for (const duplicate of duplicates) {
                duplicate.style.display = 'table-row';
            }
            for (const invalid of invalidDates) {
                invalid.style.display = 'table-row';
            }
        },
        filterAnnulled(){
            this.participations = this.originalParticipations;
            this.colorView = 'info';
            if (this.participationView === 'valid') {
                this.participations = this.participations.filter(item => item.isInvalid === 0)
                this.colorView = 'success';
            }
            if (this.participationView === 'annulled') {
                // this.participations = this.participations.filter(item => item.Descricao.toUpperCase().includes(this.filters.description.toUpperCase()))
                this.participations = this.participations.filter(item => item.isInvalid === 1)
                this.colorView = 'error';
            }
            if (this.participationView === 'duplicatedOutbound'){
                this.participations = this.participations.filter(item => item.duplicated === 1 || item.purchaseDate < '2026-02-01' || item.purchaseDate > '2026-03-31')
                this.colorView = 'warning';
            }
        }
    },
    computed:{
        totalParticipation(){
            let aux = 0;
            for (const item of this.participations) {
                aux += item.NumParticipations
            }
            return aux;
        },
        totalOriginalParticipation(){
            let aux = 0;
            for (const item of this.originalParticipations) {
                aux += item.NumParticipations
            }
            return aux;
        }
    }
}
</script>
<style>

.duplicated-line {
    background-color: lightyellow;
}

.invalid-date {
    background-color: lightpink;
}
</style>
